import { computed, defineComponent } from 'vue'
import type { IDataBodyProps } from './types'
import { DataRow } from '../data-row'
import { uref } from '@/utils/reactive/uref';
import { blurClass } from '@/utils/style'

export const DataBody = defineComponent<IDataBodyProps>(
  (props) => {
    const rows = computed(() => uref(props.rows));
    const blurCls = computed(() => props.blur ? blurClass : '')

    return () => {
      return (
        <tbody class={`relative ${blurCls.value}`}>
          {rows.value.map((row, i) => {
            return <DataRow table={props.table} variant={props.variant} row={row} key={row.value.id || `${i}`} selected={row.value.selected}/>
          })}
        </tbody>
      )
    }
  },
  { props: ['rows', 'variant', 'table', 'blur'] }
)
